declare global {
  interface Window {
    YzsRequestHelper: typeof YzsRequestHelper;
  }
}

export class YzsRequestHelper {
  static _menuCache: any[] | null = null;

  static getMenuData() {
    if (this._menuCache) return this._menuCache; // 已缓存直接返回

    try {
      const raw = localStorage.getItem('YZSALL_menuList');
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return null;
      this._menuCache = parsed; // 缓存下来
      return this._menuCache;
    } catch (err) {
      console.error('解析 YZSALL_menuList 出错:', err);
      return null;
    }
  }


  static getModalTitle() {
    const titleElement = document.querySelector(".yzs-tabs-container .ant-tabs-tab-active");
    const targetName = titleElement ? titleElement.textContent : "工作台";

    const data = this.getMenuData();
    if (!data && targetName === "工作台") {
      return targetName
    }

    let result = null;

    function dfs(nodes: any[], parentName = null) {
      for (const node of nodes) {
        if (node.name === targetName) {
          result = parentName;
          return true; // 找到了就结束递归
        }
        if (node.children && node.children.length > 0) {
          if (dfs(node.children, node.name)) return true;
        }
      }
      return false;
    }
    dfs(data!);

    return `${result ? result + "/" : ""}${targetName}`;
  }

  static buildHeaders(param: Record<string, any> = {}) {
    // const pageName = this.getPageName(location.hash);
    // const menulist = this.getMenuText(pageName);
    const menulist = []
    const modalTitle = this.getModalTitle();
    if (modalTitle) menulist.push(modalTitle);

    const idValues = Object.keys(param)
      .filter((key) => key.toLowerCase().includes("id"))
      .map((key) => param[key]);

    return {
      "X-Request-Menu": encodeURI(menulist.join("/").slice(0, 100)),
      "X-Request-Biz": encodeURI(idValues.join("/").slice(0, 50)),
    };
  }
}

window.YzsRequestHelper = YzsRequestHelper;